// Função para converter segundos em formato "Xh Ym"
export function secondsToHoursMinutes(seconds: number): string {
  if (!seconds || isNaN(seconds)) return "0h 0m";

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  return `${hours}h ${minutes}m`;
}

// Tipos para os dados dos cards
export interface CardDataItem {
  title: string;
  key: string; // Chave para acessar no objeto de resposta da API
  value: number | string;
  unit: string;
  defaultValue: number | string; // Valor padrão quando não há dados
  formatter?: (value: any) => number | string; // Função opcional para formatar o valor
}

// Template para os cards com valores padrão
export const cardDataTemplate: CardDataItem[] = [
  {
    title: "Distância total",
    key: "total_distance",
    value: 0,
    unit: "km",
    defaultValue: 0,
  },
  {
    title: "Distância entre batidas",
    key: "distance_between_clockins",
    value: 0,
    unit: "km",
    defaultValue: 0,
  },
  {
    title: "Distância fora das batidas",
    key: "distance_outside_clockins",
    value: 0,
    unit: "km",
    defaultValue: 0,
  },
  {
    title: "Tempo em trânsito fora batidas",
    key: "transit_time_outside_clockins",
    value: "0h 0m",
    unit: "",
    defaultValue: "0h 0m",
    formatter: secondsToHoursMinutes,
  },
  {
    title: "Tempo total fora do ponto",
    key: "total_time_outside_clockins",
    value: "0h 0m",
    unit: "",
    defaultValue: "0h 0m",
    formatter: secondsToHoursMinutes,
  },
  {
    title: "Velocidade Máxima",
    key: "max_speed",
    value: 0,
    unit: "km/h",
    defaultValue: 0,
  },
  {
    title: "Tempo em trânsito dentro batidas",
    key: "transit_time_inside_clockins",
    value: "0h 0m",
    unit: "",
    defaultValue: "0h 0m",
    formatter: secondsToHoursMinutes,
  },
  {
    title: "Tempo estacionado",
    key: "total_stationary_work_time",
    value: "0h 0m",
    unit: "",
    defaultValue: "0h 0m",
    formatter: secondsToHoursMinutes,
  },
];

// Função para criar os cards com valores iniciais
export function getInitialCardData(): CardDataItem[] {
  return cardDataTemplate.map((card) => ({ ...card }));
}

// Função para atualizar os cards com dados da API
export function updateCardDataFromApi(apiData: any): CardDataItem[] {
  return cardDataTemplate.map((card) => {
    let value;

    if (apiData[card.key] !== undefined) {
      // Se tiver uma função formatadora, aplica ela
      if (card.formatter) {
        value = card.formatter(apiData[card.key]);
      } else {
        value = apiData[card.key];
      }
    } else {
      value = card.defaultValue;
    }

    return {
      ...card,
      value,
    };
  });
}
